import LegalPage from '@/components/LegalPage';

const licenseContent = `# SeekScape — License Agreement

**Effective Date:** April 6, 2026

## 1. Grant of License

SeekScape grants you a limited, non-exclusive, non-transferable, revocable license to access and use the SeekScape application ("App") and its content, subject to the terms of this agreement.

## 2. Wallpaper Usage Rights

- **Purchased Wallpapers:** Upon completing a valid purchase using SKR tokens, you are granted a personal, non-commercial license to download, store, and use the wallpaper on your personal devices.
- **Restrictions:** You may not redistribute, resell, sublicense, or publicly display purchased wallpapers. Wallpapers may not be used in commercial products, merchandise, or for any profit-generating purpose without prior written consent.
- **Preview Content:** Unpurchased wallpapers displayed in the App are watermarked and low-resolution previews intended for browsing purposes only. Capturing, reproducing, or distributing preview content is prohibited.

## 3. Intellectual Property

All wallpapers, images, designs, logos, branding, and other creative assets available through SeekScape are the property of their respective creators and/or SeekScape. Purchasing a wallpaper does not transfer intellectual property rights.

## 4. Blockchain Transactions

All purchases are processed on the Solana blockchain. Transactions are final and non-refundable. SeekScape is not responsible for transaction fees, network delays, or wallet-related issues.

## 5. Prohibited Uses

You agree not to:
- Reverse-engineer, decompile, or disassemble any part of the App
- Use automated tools to scrape, download, or extract content
- Circumvent watermarks, blur protections, or other security measures
- Use the App for any illegal or unauthorized purpose

## 6. Termination

SeekScape reserves the right to terminate or suspend your access at any time, without notice, for violation of these terms.

## 7. Disclaimer of Warranties

The App and its content are provided "as is" without warranties of any kind, express or implied. SeekScape does not guarantee uninterrupted or error-free service.

## 8. Limitation of Liability

SeekScape shall not be liable for any indirect, incidental, special, or consequential damages arising from use of the App.

## 9. Changes to This License

SeekScape reserves the right to update this license at any time. Continued use of the App constitutes acceptance of any changes.

## 10. Contact

For questions about this license, please reach out through the SeekScape application.`;

export default function LicensePage() {
  return <LegalPage title='License Agreement' content={licenseContent} />;
}
